export default {
  InsufficientBalance: {
    en: 'Insufficient balance',
    ja: '残高不足'
  },
  TransactionFailed: {
    en: 'Transaction failed',
    ja: '処理に失敗しました'
  },
  Days: {
    en: 'Days',
    ja: '日々'
  },
  hours: {
    en: 'hours',
    ja: '時間'
  },
  Owned: {
    en: 'Owned',
    ja: '所有'
  },
  AllocationUpTo: {
    en: 'Allocation up to',
    ja: 'までの割り当て'
  },
  Price: {
    en: 'Price',
    ja: '価格'
  },
  Locked: {
    en: 'Locked',
    ja: 'ロック済み'
  },
  Claimable: {
    en: 'Claimable',
    ja: 'クレーム可能'
  },
  AlreadyClaimed: {
    en: 'Already claimed',
    ja: 'すでに主張'
  },
  Claim: {
    en: 'Claim',
    ja: '請求'
  },
  YourTickets: {
    en: 'Your tickets',
    ja: 'あなたのチケット'
  },
  Buy: {
    en: 'Buy',
    ja: '買う'
  },
  BuyMore: {
    en: 'Buy more',
    ja: 'もっと買う'
  }
}